import { Component, forwardRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem, ConfirmationService } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../../components/Controls/MessageHandler.component';
import { BlockComponent } from '../../components/Controls/Block.component';
import { RequestValidationMessagesComponent } from '../../components/Requests/RequestValidationMessages.component';
import { CustomerValidationComponent } from '../../components/Customers/CustomerValidation.component';
import { AuthenticationService } from '../../services/Authentication.service';
import { ValidationErrors } from '@angular/forms/src/directives/validators';
import { RequestTypeEnum } from '../../enums/index';

@Component({
    selector: 'my-requestheader',
    templateUrl: './RequestHeader.component.html'
})
export class RequestHeaderComponent implements OnInit {

    public msgs: Message[] = [];
    public userInfo: ent.UserInfo;
    private requestFilter: filters.RequestFilter;

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(RequestValidationMessagesComponent) requestValidationMessagesComponent: RequestValidationMessagesComponent;
    @ViewChild(CustomerValidationComponent) customerValidationComponent: CustomerValidationComponent;

    @Input() public title: string;
    @Input() public requestID: number;
    @Input() public requestTypeID: number;
    @Input() public request: ent.Request;
    @Output() public save: EventEmitter<any> = new EventEmitter();
    @Output() public submit: EventEmitter<any> = new EventEmitter();
    @Output() public complete: EventEmitter<any> = new EventEmitter();
    @Output() public expandAll: EventEmitter<any> = new EventEmitter();
    @Output() public collapseAll: EventEmitter<any> = new EventEmitter();

    displayConfirmEmailDialog: boolean;
    displayRejectRequestDialog: boolean;
    rejectComments: string;
    disableEmailButton: boolean;
    saveInProgress: boolean;
    disableSubmitButtonDuringSubmit: boolean;
    appConfig: ent.AppConfig;

    constructor(private requestService: serv.RequestService, private authenticationService: serv.AuthenticationService,
        private confirmationService: ConfirmationService, private configService: serv.ConfigService, private customerService: serv.CustomerService) {
        this.appConfig = this.configService.appConfig;
    }

    getFullTitle(): string {
        var val = this.title;
        if (this.requestID && this.requestID > 0) {
            val = val + " - Request # " + this.requestID.toString();
        }
        return val;

    }

    //#region Logic for whether to show/disable Save, Submit, Complete and Email buttons
    showSaveButton(): boolean {
        return util.SecurityUtil.ShowSaveButton(this.request, this.userInfo);
    }

    showSubmitButton(): boolean {
        return util.SecurityUtil.ShowSubmitButton(this.request, this.userInfo);
    }

    disableSubmitButton(): boolean {
        if (this.saveInProgress === true) {
            return true;
        }
        if (this.disableSubmitButtonDuringSubmit === true) {
            return true;
        }
        return util.SecurityUtil.DisableSubmitButton(this.request);
    }

    disableSaveButton(): boolean {
        return util.SecurityUtil.DisableSaveButton(this.request);
    }

    showCompleteButton(): boolean {
        return util.SecurityUtil.ShowCompleteButton(this.request, this.userInfo);
    }

    showInProgressButton(): boolean {
        return util.SecurityUtil.ShowInProgressButton(this.request, this.userInfo);
    }

    showApproveButton(): boolean {
        return util.SecurityUtil.ShowApproveButton(this.request, this.userInfo);
    }

    disableCompleteButton(): boolean {
        return util.SecurityUtil.DisableCompleteButton(this.request);
    }

    showRejectButton(): boolean {
        return util.SecurityUtil.ShowRejectButton(this.request, this.userInfo);
    }

    disableRejectButton(): boolean {
        return util.SecurityUtil.DisableRejectButton(this.request);
    }

    showEmailButton(): boolean {
        
        let val = util.SecurityUtil.ShowEmailButton(this.request);
        return val;
    }
    //#endregion

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
    }

    onSaveClick(event: any) {
        this.saveInProgress = true;
        this.save.emit(event);
    }

    onHideConfirmEmailDialog(event: any) {
        this.displayConfirmEmailDialog = false;
    }

    //#region Send Email
    onEmailClick(event: any) {

        this.disableEmailButton = true;
        this.checkForSuppress();

    }

    isEmailDisabled() {
        if (this.requestID <= 0) {
            return false;
        }

        if (this.saveInProgress === true) {
            return true;
        }

        return this.disableEmailButton;
    }

    checkForSuppress() {

        if (this.request.SuppressInfo && (this.request.SuppressInfo.SuppressCustomer || this.request.RequestTypeID == RequestTypeEnum.SuppressCustomer)) {
            
            if (this.request.GeneralInfo.CustomerNumber && this.request.GeneralInfo.CustomerNumber != "") {
                var filter: filters.CustomerFilter = { CustomerNumber: this.request.GeneralInfo.CustomerNumber };
                this.customerService.getCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        var cust = x[0];
    
                        if (cust.OpenARBalance > 0) {
    
                            var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 2 });
    
                            this.confirmationService.confirm({
                                message: `The outlet requested to be suppressed has open invoices. Please work with the customer to submit payment. 
                                    The open balance on the account is ${formatter.format(cust.OpenARBalance)} as of ${util.DateUtil.GetCurrentDate()}. If you have questions on this balance, please reach out to 
                                    Credit@reyesccb.com. Once payment is collected, please re submit the request for suppression. 
                                    The outlet will be blocked from placing any new sales orders. Do you want to continue?`,
                                key: "cd2",
                                accept: () => {
                                    this.sendEmail();
                                },
                                reject: () => {
                                    this.blockComponent.blocked = false;
                                    this.disableEmailButton = false;
                                }
                            });
                        }
                        else {
                            this.confirmSuppress();
                        }
                
                        
                    }
                });
            }
            else {
                this.confirmSuppress();
            }
        }
        else if (this.request.GeneralInfo && this.request.GeneralInfo.IncludeOwnershipChange == true && this.request.RequestTypeID != enums.RequestTypeEnum.MaintainCustomer) {
            this.confirmationService.confirm({
                message: Constants._EMAIL_REQUEST_WITH_OWNERSHIP_CHANGE,
                key: "cd2",
                accept: () => {
                    this.sendEmail();
                },
                reject: () => {
                    this.blockComponent.blocked = false;
                    this.disableEmailButton = false;
                }
            });
        }
         else if (this.request.RequestTypeID == enums.RequestTypeEnum.InvoiceStatementCopies) {
            this.confirmationService.confirm({
                message: Constants._MIGRATED_REQUEST_TYPE_MSG,
                key: "cd2",
                accept: () => {
                    this.sendEmail();
                },
                reject: () => {
                    this.blockComponent.blocked = false;
                    this.disableEmailButton = false;
                }
            });
        }
        else {
            this.sendEmail();
        }



    }

    confirmSuppress() {
        this.confirmationService.confirm({
            message: Constants._EMAIL_REQUEST_WITH_SUPPRESS_CONFIRMATION,
            key: "cd2",
            accept: () => {
                this.sendEmail();
            },
            reject: () => {
                this.blockComponent.blocked = false;
                this.disableEmailButton = false;
            }
        });
    }

    sendEmail() {
        var filter: filters.RequestFilter = { RequestID: this.requestID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName() };

        var requestStatusID: number;
        var continueWithEmailing: boolean;
        this.requestService.getRequestStatus(filter).subscribe(x => {
            requestStatusID = x;
            if (requestStatusID == enums.RequestStatusEnum.Emailed) {
                //if (RequestUtil.IsCustomerRequest(this.request)){
                if (true) {
                    var messages: ent.ValidationMessage[] = [];
                    var message: ent.ValidationMessage = { Category: "Error", MessageText: Constants._REQUEST_ALREADY_EMAILED };
                    messages.push(message);

                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = messages;
                }
            }
            else {
                this.validatePayer(filter);
            }
            this.disableEmailButton = false;
        }
        )
    }

    validatePayer(filter: filters.RequestFilter) {
        if ((this.request.BillingInfo.PayerNumber == undefined || this.request.BillingInfo.PayerNumber == "") && 
            this.request.RequestTypeID == enums.RequestTypeEnum.SoldToCustomer &&
            this.request.PricingInfo.CustomerOwnershipID != enums.CustomerOwnershipEnum.Corporate) {
                var msg = "You have not selected a Payer. This can be done in the Billing Address section using one of the following methods: 1) Select the Payer directly; 2) Specify the Payer using the Account to Mirror, which would use the Payer from that existing Sold To Customer; 3) Select the Payer from a list of Payers potentially matching the Sold To Customer’s name and Address; 4) By entering the address manually.  If entering the address manually, please select the Continue Emailing without selecting Payer button below.";
                this.confirmationService.confirm({
                    message: msg,
                    key: "cd5",
                    accept: () => {
                        this.emailRequest(filter);
                    },
                    reject: () => {
                        this.blockComponent.blocked = false;
                        this.disableEmailButton = false;
                    }
                });
        }
        else {
            this.emailRequest(filter);
        }
    }

    onEmailYesClick(event: any) {
        var filter: filters.RequestFilter = { RequestID: this.requestID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName() };
        this.emailRequest(filter);
        this.displayConfirmEmailDialog = false;
    }

    onEmailCancelClick(event: any) {
        this.displayConfirmEmailDialog = false;
    }

    emailRequest(filter: filters.RequestFilter) {
        this.blockComponent.blocked = true;
        this.requestService.emailRequest(filter).subscribe(x => {
            if (x.Success) {
                this.messageHandlerComponent.handleResponse(x);
                this.blockComponent.blocked = false;
            }
            else {
                this.requestValidationMessagesComponent.messages = x.ValidationMessages;
                if (x.Customers && x.Customers.length > 0){
                    this.customerValidationComponent.displayDialog = true;
                    this.customerValidationComponent.setCustomers(x.Customers);
                    this.requestFilter = filter;
                    this.requestFilter.BypassCustomerValidation = true;
                }
                else {
                    this.requestValidationMessagesComponent.displayDialog = true;
                }
                this.blockComponent.blocked = false;
            }
        });
    }
    //#endregion

    onValidateCustomerYes(event: any){
        if (this.requestValidationMessagesComponent.messages.length > 0){
            this.requestValidationMessagesComponent.displayDialog = true;
        }
        else {
            this.emailRequest(this.requestFilter);
        }

    }

    onValidateCustomerCancel(event: any){

    }

    onSubmitClick(event: any) {
        this.checkForApprovalNeeded();
    }

    checkForApprovalNeeded() {

        var confirm = this.request.RequestTypeID == enums.RequestTypeEnum.FullServicePricing && this.request.FullServicePricingInfo &&
            this.request.FullServicePricingInfo.ZQCustomerSalesOfficeID != this.userInfo.SalesOffice.ID;

        if (confirm) {
            this.confirmationService.confirm({
                message: Constants._SUBMIT_REQUEST_WITH_DIFFERENT_SALES_OFFICE,
                key: "cd2",
                accept: () => {
                    this.submitRequest();
                },
                reject: () => {
                    this.blockComponent.blocked = false;
                }
            });
        }
        else {
            this.submitRequest();
        }



    }

    submitRequest() {
        this.blockComponent.blocked = true;
        this.disableSubmitButtonDuringSubmit = true;
        if (util.SecurityUtil.SubmitUsingAPI(this.request.RequestType)) {
            
            this.blockComponent.blockText = Constants._BLOCK_TEXT_SUBMIT_PARTNER_FUNCTION;
        }
        
        var filter: filters.RequestFilter = { RequestID: this.requestID, AppVersion: this.appConfig.Version, BrowserName: util.RequestUtil.getBrowserName() };
        this.requestService.submitRequest(filter).subscribe(x => {
            this.submit.emit();
            
            if (util.SecurityUtil.SubmitUsingAPI(this.request.RequestType)){
                this.requestValidationMessagesComponent.showCategoryColumn = false;
                this.requestValidationMessagesComponent.showIconColumn = true;
                this.requestValidationMessagesComponent.displayDialog = true;
                this.requestValidationMessagesComponent.isModal = true;
                this.requestValidationMessagesComponent.messages = x.ValidationMessages;
            }
            else {
                this.messageHandlerComponent.handleResponse(x);
            }
            
            this.blockComponent.blocked = false;
            this.blockComponent.blockText = "";
            this.disableSubmitButtonDuringSubmit = false;

        });
    }

    onCompleteClick(event: any) {
        this.blockComponent.blocked = true;
        var filter: filters.RequestFilter = { RequestID: this.requestID };
        var completeRequest: ent.CompleteRequestsRequest = { Requests: [this.request], ValidateCompletionNumbers: true, Employee: this.userInfo.Employee };
        this.requestService.completeRequest(completeRequest).subscribe(x => {
            if (x.Success) {
                this.complete.emit(event);
                this.messageHandlerComponent.handleResponse(x)
            }
            else {
                this.requestValidationMessagesComponent.displayDialog = true;
                this.requestValidationMessagesComponent.messages = x.ValidationMessages;
            }
            this.blockComponent.blocked = false;

        });
    }

    onInProgressClick(event: any) {
        this.blockComponent.blocked = true;
        var filter: filters.RequestFilter = { RequestID: this.requestID, ActionEmployeeID: this.userInfo.Employee.ID };
        this.requestService.inProgressRequest(filter).subscribe(x => {
            if (x.Success) {
                this.complete.emit(event);
                this.messageHandlerComponent.handleResponse(x)
            }
            else {
                this.requestValidationMessagesComponent.displayDialog = true;
                this.requestValidationMessagesComponent.messages = x.ValidationMessages;
            }
            this.blockComponent.blocked = false;

        });
    }

    onApproveClick(event: any) {

        switch(this.requestTypeID)
        {
            case enums.RequestTypeEnum.EquipmentInstall:
            case enums.RequestTypeEnum.EquipmentSwap:
                this.submitRequest();
                break;
            default:
                this.onEmailClick(event);
                break;
        }
        
    }

    onRejectClick(event: any) {
        switch (this.request.RequestTypeID) {
            case enums.RequestTypeEnum.SuppressCustomer:
            case enums.RequestTypeEnum.UnsuppressCustomer:
                this.rejectComments = Constants._DEFAULT_REJECT_COMMENTS_FOR_SUPPRESSION_REQUESTS;
                break;
            default:
                this.rejectComments = "";
                break;
        }
        this.displayRejectRequestDialog = true;
    }

    onRejectYesClick(event: any) {
        this.rejectRequest();
        this.displayRejectRequestDialog = false;
    }

    onRejectCancelClick(event: any) {
        this.displayRejectRequestDialog = false;
    }

    onHideRejectRequestDialog(event: any) {
        this.displayRejectRequestDialog = false;
    }

    rejectRequest() {
        this.blockComponent.blocked = true;
        var filter: filters.RequestFilter = { RequestID: this.requestID, Comments: this.rejectComments };
        this.requestService.rejectRequest(filter).subscribe(x => {
            if (x.Success) {
                this.messageHandlerComponent.handleResponse(x)
            }
            else {
                this.requestValidationMessagesComponent.displayDialog = true;
                this.requestValidationMessagesComponent.messages = x.ValidationMessages;
            }
            this.blockComponent.blocked = false;

        });
    }

    onExpandAllClick(event: any) {
        this.expandAll.emit(event);
    }

    onCollapseAllClick(event: any) {
        this.collapseAll.emit(event);
    }

    handleResponse(response: ent.Response) {

        this.messageHandlerComponent.handleResponse(response);

    }

}